import * as _ from 'lodash';
import store from '@/store/store';
import priceFormat from '@/filters/priceFormat';
import { capitalize } from '@/common/utils/strings';
import { ParentsService } from '@/common/services/pages/parents.service';
import { SchoolCampService } from '@/common/services/pages/camps.service';
import { SchoolClassService } from '@/common/services/pages/classes.service';
import { SchoolAftercareService } from '@/common/services/pages/aftercare.service';
import { TransactionsService } from '@/common/services/pages/transactions.service';
import * as Mutations from './mutations';

export const StatsModule = {
    state: {
        stats: [],
        isNewPaymentSystem: false,
        isStatsLoading: true
    },

    mutations: {
        [Mutations.SET_STATS](state, payload) {
            state.stats = payload;
        },

        [Mutations.REMOVE_STATS](state) {
            state.stats = [];
        },
        [Mutations.SET_IS_NEW_PAYMENT_SYSTEM](state, payload) {
            state.isNewPaymentSystem = payload;
        },
        [Mutations.SET_STATS_LOADING](state, payload) {
            state.isStatsLoading = payload;
        }
    },

    actions: {
        async getClassesGeneralInfo(context) {
            const { data } = await SchoolClassService.getClassesGeneralInfo(context.getters.schoolId);
            data.capacity += '%';
            const tooltips = [
                'Includes online and offline classes',
                'Unique children',
                'Includes online and offline classes'
            ];
            const stats = _.entries(data).map(([key, value], index) => ({
                label: capitalize(key),
                data: value,
                tooltip: tooltips[index]
            }));
            context.commit(Mutations.SET_STATS, stats);
        },

        async getCampsGeneralInfo(context) {
            const { data } = await SchoolCampService.getCampsGeneralInfo(context.getters.schoolId);
            data.capacity += '%';
            const tooltips = [
                'Includes online and offline camps',
                'Unique children',
                'Includes online and offline camps'
            ];
            const stats = _.entries(data).map(([key, value], index) => ({
                label: capitalize(key),
                data: value,
                tooltip: tooltips[index]
            }));
            context.commit(Mutations.SET_STATS, stats);
        },

        async getAftercareGeneralInfo(context) {
            const { data } = await SchoolAftercareService.getAftercareGeneralInfo(context.getters.schoolId);
            data.capacity += '%';
            const tooltips = [
                'Includes online and offline sessions',
                'Unique children',
                'Includes online and offline sessions'
            ];
            const stats = _.entries(data).map(([key, value], index) => ({
                label: capitalize(key),
                data: value,
                tooltip: tooltips[index]
            }));
            context.commit(Mutations.SET_STATS, stats);
        },

        async getAftercareDetailsGeneralInfo(context, aftercareDayId) {
            const { data } = await SchoolAftercareService.getAftercareDetailsGeneralInfo(context.getters.schoolId, aftercareDayId);
            const tooltips = [
                'Enrolled',
                'WaitList',
                'Drop-In'
            ];
            context.dispatch('toggleActivityDropInPage', data.showDropIn);
            data.showDropIn
                ? delete data.showDropIn
                : delete data.showDropIn && delete data.dropIn;

            const stats = _.entries(data).map(([key, value], index) => ({
                label: key === 'dropIn' ? 'Drop-in' : capitalize(key),
                data: value,
                tooltip: tooltips[index]
            }));
            context.commit(Mutations.SET_STATS, stats);
        },

        async getClassDetailsGeneralInfo(context, classId) {
            const { data } = await SchoolClassService.getClassDetailsGeneralInfo(context.getters.schoolId, classId);
            const tooltips = [
                'Enrolled',
                'WaitList'
            ];
            const stats = _.entries(data)
            .filter(([key]) => key !== 'maxEnroll' && key !== 'maxWaitList')
            .map(([key, value], index) => ({
                label: capitalize(key),
                data: value,
                tooltip: tooltips[index]
            }));
            context.commit(Mutations.SET_STATS, stats);
        },

        async getCampDetailsGeneralInfo(context, campPricingId) {
            const { data } = await SchoolCampService.getCampDetailsGeneralInfo(context.getters.schoolId, campPricingId);

            const tooltips = [
                'Enrolled',
                'WaitList'
            ];
            const stats = _.entries(data)
            .filter(([key]) => key !== 'maxEnroll' && key !== 'maxWaitList')
            .map(([key, value], index) => ({
                label: capitalize(key),
                data: value || 0,
                tooltip: tooltips[index]
            }))

            context.commit(Mutations.SET_STATS, stats);
        },

        async getTransactionsGeneralInfo(context) {

            try {
                context.commit(Mutations.SET_STATS_LOADING, true);
                const { schoolInfo } = context.getters;
                const isNewPaymentSystem = schoolInfo.features["new-payments"];
                context.commit(Mutations.SET_IS_NEW_PAYMENT_SYSTEM, isNewPaymentSystem);
    
                const { schoolId } = context.getters;
                const { data } = await TransactionsService.getTransactionsGeneralInfo(schoolId);
                const stats = _.entries(data).map(([key, value], index) => ({
                    label: capitalize(key),
                    data: store.getters.currencySign + ' ' + priceFormat(value),
                }));
                context.commit(Mutations.SET_STATS, []);
            } catch (error) {
           
            } finally {
                context.commit(Mutations.SET_STATS_LOADING, false);
            }
        },

        setStats(context, stats) {
            context.commit(Mutations.SET_STATS, stats);
        },

        removeStats(context) {
            context.commit(Mutations.REMOVE_STATS);
        }
    },

    getters: {
        stats: state => state.stats,
        isNewPaymentSystem: state => state.isNewPaymentSystem,
        isStatsLoading: state => state.isStatsLoading
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/stats/stats.module.js